{
    "ServerStatus_heading_applicationProperties": "Propriétés de l'application",
    "ServerStatus_action_refresh": "Actualiser l'état",
    "NAME": "État du serveurLangue"
}